export const ERROR_MESSAGES = {
  DEALER_LOAD_FAILED: "Falha ao carregar dados da revenda",
  PROVIDERS_UPDATE_FAILED: "Falha ao atualizar lista de provedores",
  PROVIDER_DELETE_FAILED:
    "Não foi possível excluir o provedor. Tente novamente!",
  PROVIDER_DELETE_SUCCESS: "Provedor excluído com sucesso!",
} as const;
